import { CustomerStatus } from 'src/constants/customer/enums'
import type { Customer } from 'src/interfaces/customer'

export const resolveCustomerDisplayName = (customer: Customer): string => {
  const displayName = customer.displayName?.trim()

  if (displayName) {
    return displayName
  }

  return customer.name
}

export const isCustomerInactive = (customer: Customer): boolean => {
  return customer.status === CustomerStatus.Deleted
}

/** Onboarding and profile-document values are only meaningful for master contractors. */
export const shouldShowMasterContractorValue = (customer: Customer): boolean => {
  return customer.isMasterContractor
}

export const isCustomerOnboardedAsMasterContractor = (customer: Customer): boolean => {
  return Boolean(customer.isMasterContractor && customer.masterContractorOnboardedAt)
}

interface CustomerListFilters {
  status: CustomerStatus | null
  search: string
}

export const filterCustomers = (
  customers: Customer[],
  filters: CustomerListFilters,
): Customer[] => {
  const search = filters.search.trim().toLowerCase()

  return customers.filter((customer) => {
    if (filters.status !== null && customer.status !== filters.status) {
      return false
    }

    if (search === '') {
      return true
    }

    const haystack = [resolveCustomerDisplayName(customer), customer.name, customer.id]

    return haystack.some((value) => {
      return value.toLowerCase().includes(search)
    })
  })
}
